import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CustomerObject } from 'src/app/_interfaces/cinema/CustomerObject';
import { environment } from 'src/environments/environment';

const API_URL = environment.prismaApiUrl +'/api/common/documents';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {
  currentObject: any;
  isNew: Boolean = false;
  document: any = [];

  constructor(private http: HttpClient) { }

  getAll(): Observable<any> {
    return this.http.get(API_URL);
  }

  setDocData(document) {
      this.document = document;
  }

  getDocData() {
      return this.document;
  }

  getAllModuleDocuments(moduleId: number, moduleItemId: number, type: string): Observable<any> {
    return this.http.get(API_URL + '/get-all-module-documents/' + moduleId + '/' + moduleItemId + '/' + type);
  }

  getDocumentTypes(): Observable<any> {
    return this.http.get(API_URL + '/get-document-types');
  }

  updateDocument(documentData: any): Observable<any> {
    return this.http.put(API_URL + '/update-document/' + documentData.id, documentData);
  }

  getModuleDocument(id: any, module_id: any, type: any, parent_id?: any): Observable<any> {
    let url = API_URL + '/get_module_documents/' + id + '/' + module_id + '/' + type;
    if (parent_id !== undefined && parent_id !== null && parent_id !== '') {
      url += '/' + parent_id;
    }
    console.log('Service URL:', url);
    return this.http.get(url);
  }

  getThumbnail(object: any): Observable<any> {
    return this.http.get(API_URL + '/getThumbnail/' + object.id, { responseType: 'blob' });
  }
  /*
  store(object: any, module_id,): Observable<any> {
    return this.http.post<CustomerObject>(API_URL, {data: object, module: 2, module_item_id: 1});
  }
  */
  getImage(object: any): Observable<any> {
    return this.http.get(API_URL + '/getImage/' + object.id);
  }
 

  delete(object: any): Observable<any> {
    return this.http.delete(API_URL + '/' + object.id);
  }

  download(object: any): Observable<any> {
    this.currentObject = this.http.get(API_URL + '/download/' + object.id, { responseType: 'blob' });
    return this.currentObject;
  }

  showDocument(object: any): Observable<any> {
    this.currentObject = this.http.get(API_URL + '/showDocument/' + object.id, { responseType: 'blob' });
    return this.currentObject;
  }

  show(object: any): Observable<any> {
    //alert(object.id);
    this.currentObject = this.http.get(API_URL + '/' + object.id, { responseType: 'blob' });
    return this.currentObject;
  }

  combine(files: any, data: any, file_name: any, store: Boolean): Observable<any> {
    this.currentObject = this.http.post(API_URL + '/combine', {files: files, data: data, file_name: file_name, store: store}, { responseType: 'blob' });
    return this.currentObject;
  }

  upload(files): Observable<any> {
    return this.http.post(API_URL + '/upload', files);
  }

  update(object: any): Observable<any> {
    return this.http.put<CustomerObject>(API_URL + '/' + object.id, {data: object});
  }

  genPDF(): Observable<any> {
    return this.http.get(API_URL + '/gen-pdf', {responseType: 'arraybuffer'});
  }

  getCurrentObject() {
    return this.currentObject;
  }

  setIsNew(value: any) {
    this.isNew = value;
  }

  getIsNew() {
    return this.isNew;
  }

  // Ordner-spezifische Methoden
  createFolder(folderData: any): Observable<any> {
    return this.http.post(API_URL + '/create-folder', folderData);
  }

  updateFolder(folderData: any): Observable<any> {
    return this.http.put(API_URL + '/update-folder/' + folderData.id, folderData);
  }

  deleteFolder(folder: any): Observable<any> {
    return this.http.delete(API_URL + '/delete-folder/' + folder.id);
  }

  getFolderPath(folderId: number): Observable<any> {
    return this.http.get(API_URL + '/get-folder-path/' + folderId);
  }

  getAllFolders(moduleItemId: number): Observable<any> {
    return this.http.get(API_URL + '/get-all-folders/' + moduleItemId);
  }

  moveFile(fileId: number, targetFolderId: number | null): Observable<any> {
    const data = {
      file_id: fileId,
      target_folder_id: targetFolderId
    };
    return this.http.put(API_URL + '/move-file', data);
  }

  downloadFolderAsZip(folderId: number): Observable<any> {
    return this.http.get(API_URL + '/download-folder-zip/' + folderId, { responseType: 'blob' });
  }
}
